export const UNIT_TYPE_PHRASE             = 'phrase';
export const UNIT_TYPE_PHRASE_LOCALISED   = 'phrase-localised';
export const UNIT_TYPE_MULTIPLE           = 'multiple-choice';
export const UNIT_TYPE_MULTIPLE_NO_IMAGES = 'multiple-choice-without-images';
export const UNIT_TYPE_LISTEN_TYPE        = 'listen-and-type';
export const UNIT_TYPE_FILL_IN_THE_GAPS   = 'fill-in-the-gaps';

export const UNIT_MARK_PASSED = 'passed';
export const UNIT_MARK_FAILED = 'failed';
